module.exports = [
  require('./list/avatar_of_death'),
  require('./list/giant_fly'),
]
